import React from "react";

import cx from 'classnames';
import styles from "./layouts.module.scss";

const GridView = ({ children, width, rowSpacing, columnSpacing, alignment, className }) => {
  const widgetStyles = {
    rowGap: `${rowSpacing}px`,
    columnGap: `${columnSpacing}px`,
    gridTemplateColumns: `repeat(auto-fit, ${width})`,
    justifyContent: alignment
  }

  return (
    <div
      className={cx(styles.grid, className)}
      style={widgetStyles}
    >
      {children}
    </div>
  );
};

export default GridView;
